<template>
   <b-button size="sm" variant="outline-primary" @click="handleClick">Back</b-button>
</template>

<script>

import {mapActions} from "vuex";

export default {
  name: 'BackButton',
  props: {
    serialNum: {
      type: String,
      required: true
    },
    fromDevicePage: {
      type: Boolean,
      required: false
    }
  },
  methods: {
    ...mapActions("dashboard", [
      "setSelectedDevice",
    ]),
    handleClick() {
      this.setSelectedDevice(this.serialNum)
      this.$router.back()
    }
  }
}
</script>

<!-- Sidebar styles should be scoped -->
<style src="./BackButton.scss" lang="scss" scoped/>
